<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-40 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <md-card>
        <md-card-header
          :class="{'md-card-header-green': verifyTenantIsNotImaOrIpmc, 'md-card-header-rocketred': verifyTenantIsImaOrIpmc}"
        >
          <h3 class="title">{{verifyTenantIsNotImaOrIpmc ? $t('login.loginToOmni') : 'Login'}}</h3>
        </md-card-header>
        <md-card-content>
          <md-field class="md-form-group">
            <md-icon>person</md-icon>
            <label>Login</label>
            <md-input v-model="email" type="email" @keyup.enter="login" required></md-input>
          </md-field>
          <md-field class="md-form-group">
            <md-icon>lock_outline</md-icon>
            <label>{{$t('login.password')}}</label>
            <md-input v-model="password" type="password" @keyup.enter="login"  required></md-input>
          </md-field>
        </md-card-content>
        <v-row>
          <v-col>
            <md-button
              :class="['md-simple', 'md-info']"
              style="
                border: 1px solid #00bcd4;
                padding: 0 15%;
                text-transform: none;
                font-size: 16px;
              "
              :disabled="loading"
              :dark="loading"
              @click="login"
              >{{$t('login.getIn')}}</md-button
            >
          </v-col>
        </v-row>
        <!-- <div v-if="isDataPrev" style="margin: 15px 0;">
          Ou
          <div id="openid_container" style="margin: 10px 0;">
            <a style="cursor: pointer;" @click="authOidc()" id="openid_link">
              <img title="Para acesso via GERID clique aqui" class="oid-idpLogo"
                src="../../src/assets/img/login_gerid.png" />
            </a>
          </div>
        </div> -->
        <!-- <v-row no-gutters>
          <v-col>
            <md-button class="md-simple md-info">Esqueceu a senha?</md-button>
          </v-col>
        </v-row> -->
      </md-card>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import SecurityService from '@/gerid/SecurityService'
import isTenantMixin from '@/components/mixins/isTenantMixin'

export default {
  data () {
    return {
      securityService: new SecurityService(),
      loading: false,
      tenant: '',
      email: '',
      password: ''
    }
  },
  mixins: [isTenantMixin],
  computed: {
    verifyTenantIsNotImaOrIpmc () {
      return this.tenant !== 'ima' && this.tenant !== 'ipmc'
    },
    verifyTenantIsImaOrIpmc () {
      return this.tenant === 'ima' || this.tenant === 'ipmc'
    }
  },
  methods: {
    async authOidc () {
      await this.securityService.getSignedIn()
    },
    async login () {
      this.loading = true
      Swal.fire({
        title: this.$t('commonWords.loading') + '...',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        }
      })
      try {
        // const env = location.host.split('-')?.[0]
        const result = await axios.post(
          `${process.env.VUE_APP_AUTH_BASE_URL}/auth/login`,
          {
            env: this.env,
            login: this.email,
            tenant: this.tenant,
            pswd: this.password
          }
        )
        this.$store.commit('auth/login', result.data)
        if (this.isIma || this.isIpmc) {
          await this.$router.push('/templates')
        } else {
          await this.$router.push('/')
        }
        Swal.close()
        // console.log(`result`, result)
      } catch (err) {
        const errorMessageMap = {
          500: this.$t('login.internalErrorContactYourAdministrator'),
          401: err.response?.data?.message === 'USER_INACTIVE'
            ? this.$t('login.inactiveAccount')
            : this.$t('login.incorrectPassword'),
          403: this.$t('login.youAreNotAllowedToPerformThisOperation'),
          404: this.$t('login.userNotFound'),
          422: this.$t('login.thereWasAnErrorInYourRequest')
        }
        let errorText = ''
        if (err.isAxiosError) {
          errorText = errorMessageMap[err.response.status]
        } else {
          errorText = errorMessageMap[500]
        }
        Swal.fire({
          icon: 'error',
          title: this.$t('login.loginError'),
          text: errorText,
          showConfirmButton: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style>
.grid-container {
  display: grid;
  grid-template-columns: auto auto auto auto;
}

.oid-idpLogo {
  width: 80% !important;
}
</style>
